import { generateResourceSelectors } from '../generators/resource.selectors';
import * as types from './user-tenants.types';

export const userTenantsSelectors = {
  ...generateResourceSelectors<types.ITenant>((state) => state.resource.userTenants),
};
